module.exports = {
  ACCESS_TOKEN: "token",
  REFRESH_TOKEN: "refresh_token",
  USER_INFO: "Info",
  serviceHost: "/api",
  GSTIN_LinkValid: "InternalUser",
  NAME_REG_EXP: /^[a-zA-Z' ]{0,}$/,
  Alphabet_REG_EXP: /^[a-zA-Z]\w/,
  EMAIL_REG_EXP: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
  PASSWORD_REG_EXP: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&!?.*])[0-9a-zA-Z@#$%^&!?.*]{8,}$/,
  FAX_REG_EXP: /^\+?[0-9]{7,}$/,
  DateFormat: /^((0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-[12]\d{3})+$/,
  NUMBERS_ONLY_REG_EXP: /^[0-9\b]+$/,
  GST_REG_EXP: /^([0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[Z]{1}[0-9a-zA-Z]{1})|([0-9]{4}[A-Z]{3}[0-9]{5}[UO]{1}[N][A-Z0-9]{1})|([0-9]{2}[a-zA-Z]{4}[0-9]{5}[a-zA-Z]{1}[0-9]{1}[Z]{1}[0-9]{1})|([0-9]{4}[a-zA-Z]{3}[0-9]{5}[N][R][0-9a-zA-Z]{1})|([0-9]{2}[a-zA-Z]{4}[a-zA-Z0-9]{1}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[D]{1}[0-9a-zA-Z]{1})|([0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[C]{1}[0-9a-zA-Z]{1})|([9][9][0-9]{2}[a-zA-Z]{3}[0-9]{5}[O][S][0-9a-zA-Z]{1})$/,
  PAN_REG_EXP: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  TAN_REG_EXP: /^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/,
  companyName_Exp: /^([a-zA-Z0-9]{1,})[a-zA-Z'\-\. ]{0,}$/,
  NAME_HYPHEN_REG_EXP: /^[a-zA-Z0-9' -_]+$/,
  FUNCTIONALITY: {
    bankDetails: "Bank Details",
    generateXMLCSV: "Regenerate KYC XML/CSV",
    kyc: "KYC",
    downloadKyc: "Download KYC",
    queries: "Queries",
    user: "User",
    accessRights: "Access Rights",
    reports: "Reports",
    client: "Client",
    contacts: "Contacts",
    addresses: "Addresses",
    businessEntity: "Business Entity",
    supplierAnalysis: "Supplier Analysis",
    taxId: "Tax Id",
    accountAnalysis: "Account Analysis",
    transactionAnalysis: "Transaction Analysis",
    kycStatus: "KYC Status",
    newQuery: "New Query",
    allQueries: "All Queries",
    dashboard: "Dashboard",
    kycs: "KYCS",
    changeClientType: "Change Client Type",
    searchClient: "Search Client",
    searchUsers: "Registration Correction",
    locationWise: "Location-wise Registration",
  },
  ENTITLEMENTS: {
    view: "View",
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    approve: "Approve",
    reject: "Reject",
    reply: "Reply",
    reopen: "Reopen",
    deactivate: "Deactivate",
  },
  ROLE: {
    itAdmin: "01",
  },
  validFileExtensions: [
    "PDF",
    "DOCX",
    "DOC",
    "XLSX",
    "XLS",
    "PNG",
    "GIF",
    "JPEG",
    "JPG",
  ],
  accountSafranCustDefault: "D000",
  accountSchedNewCustDefault: "DEBOTRS",
  accountSafranSuppDefault: "C000",
  accountSchedNewSuppDefault: "CROTHER",
  defaultListItem: { value: "", text: "--select--" },
  dmy: "dmy",
  genders: [{ name: "Male" }, { name: "Female" }, { name: "Undisclosed" }],
  ddUserType: [
    { name: "Customer", value: "Customer_" },
    { name: "Supplier", value: "Supplier_" },
    { name: "Ameya User", value: "InternalUser_" },
  ],
  ddUserTypes: [
    { name: "Customer", value: "Customer_" },
    { name: "Supplier", value: "Supplier_" },
  ],

  ddUsersTypess: [
    { name: "Customer", value: "Customer" },
    { name: "Supplier", value: "Supplier" },
  ],
  CUSTOMERTYPES: [
    "CHA",
    "AGENT",
    "LINE",
    "IMPORTER",
    "EXPORTER",
    "BIDDER",
    "OTHER",
  ],
};
